import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  useTheme,
} from "@mui/material";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import DeleteIcon from '@mui/icons-material/Delete';
const formatter = (v) =>
  v.toLocaleString("es-AR", { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  });

const TablaDescartados = ({ descartados }) => {
  const theme = useTheme();

  if (!descartados || descartados.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        overflow: "hidden",
        mt: 3,
      }}
    >
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          <DeleteIcon fontSize="small" color="error" />
          Descartados
        </Typography>
      </Box>

      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "grey.50" }}>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>ID Pedido</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Razón Social</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Dirección</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Producto</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Fecha</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Pagos</TableCell>

            {/* <TableCell align="right" sx={{ fontWeight: 600, py: 2 }}>
              Importe
            </TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {descartados.map((p, i) => (
            <TableRow
              key={i}
              sx={{
                "&:last-child td": { borderBottom: 0 },
                "&:hover": { backgroundColor: "action.hover" },
              }}
            >
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">#{p.id}</Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">{p.cliente || "-"}</Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ maxWidth: 250 }}>
                  {p.direccion_entrega || "-"}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ maxWidth: 300 }}>
                  {p.producto || "-"}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">
                  {p.fecha_format ? p.fecha_format : "-"}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">
                  {p.pagos}
                </Typography>
              </TableCell>
              
            </TableRow>
          ))}

          
        </TableBody>
      </Table>
    </Paper>
  );
};
export default TablaDescartados